export const discoveryTilesData = [
    {
        id: 'hypothesis',
        icon: '/util/app/b3-admin-hypothesis.svg', // Assuming this is the correct icon
        title: 'Hypothesis Summary',
        description: "Build your POV: Challenge assumptions with a sharp, pattern-based take on what your prospect might be struggling with — even if they haven't named it yet.",
        bgColor: 'bg-amber-400/20',
        borderColor: 'border-amber-400/20',
        textColor: 'text-amber-300',
        iconBgColor: 'bg-amber-400/10',
        tabValue: 'business-analysis' // Matches the tab value in KanbanBoard
    },
    {
        id: 'case-studies',
        icon: '/util/app/b3-admin-case-studies.svg',
        title: 'Case Studies',
        description: "Relevant case studies based on your situation and industry - tailored to your buyer's needs and language",
        bgColor: 'bg-sky-400/20',
        borderColor: 'border-sky-400/20',
        textColor: 'text-indigo-300',
        iconBgColor: 'bg-sky-400/10',
        tabValue: 'case-studies' // Matches the tab value in KanbanBoard
    },
    {
        id: 'current-to-future',
        icon: '/util/app/b3-admin-story-transform-2.svg',
        title: 'Current to Future State',
        description: "Show the shift: A clear, compelling before-and-after story that makes the value of your solution undeniable.",
        bgColor: 'bg-sky-400/20',
        borderColor: 'border-sky-400/20',
        textColor: 'text-sky-300',
        iconBgColor: 'bg-sky-400/10',
        tabValue: 'from-to' // Matches the tab value in KanbanBoard
    },
    {
        id: 'competitive-analysis',
        icon: '/util/app/b3-admin-compete-6.svg',
        title: 'Competitive Analysis',
        description: "A detailed analysis of your competitors, including their strengths, weaknesses, and strategies.",
        bgColor: 'bg-orange-400/20',
        borderColor: 'border-orange-400/20',
        textColor: 'text-orange-300',
        iconBgColor: 'bg-orange-400/10',
        tabValue: 'competitive-analysis' // Matches the tab value in KanbanBoard
    },
    {
        id: 'cost-of-inaction',
        icon: '/util/app/b3-admin-story-current.svg',
        title: 'Cost of Inaction',
        description: "Raise the stakes: The risks, losses, and missed opportunities of staying stuck — and why change matters now.",
        bgColor: 'bg-red-400/20',
        borderColor: 'border-red-400/20',
        textColor: 'text-red-300',
        iconBgColor: 'bg-red-400/10',
        tabValue: 'COI' // Matches the tab value in KanbanBoard
    },
    {
        id: 'value-proposition',
        icon: '/util/app/b3-admin-financial-analysis.svg',
        title: 'Value Assessment',
        description: "Assess the value: A clear, compelling before-and-after story that makes the value of your solution undeniable.",
        bgColor: 'bg-green-400/20',
        borderColor: 'border-green-400/20',
        textColor: 'text-green-300',
        iconBgColor: 'bg-green-400/10',
        tabValue: 'value-proposition', // Matches the tab value in KanbanBoard
    },
    {
        id: 'art-of-possible',
        icon: '/util/app/b3-admin-art-of-possible.svg',
        title: 'Art of the Possible',
        description: "Inspire the vision: A bold look at what's possible — the outcomes, advantages, and momentum your solution can unlock.",
        bgColor: 'bg-teal-400/30',
        borderColor: 'border-teal-400/30',
        textColor: 'text-teal-300',
        iconBgColor: 'bg-teal-400/10',
        tabValue: 'story-content' // Matches the tab value in KanbanBoard
    },
    {
        id: 'conversation',
        icon: '/util/app/b3-admin-conversation-kb-2.svg',
        title: 'Ask Anything',
        description: "Get instant answers: Ask anything and get deal-specific, buyer-relevant responses trained on your prospect, product, and opportunity so you're always ready to respond, adapt, and win.",
        bgColor: 'bg-orange-300/20',
        borderColor: 'border-orange-300/20',
        textColor: 'text-orange-300',
        iconBgColor: 'bg-orange-300/10',
        tabValue: 'conversation' // Matches the tab value in KanbanBoard
    },
    // {
    //     id: 'deep-dive',
    //     icon: '/util/app/b3-admin-deep-dive-research.svg',
    //     title: 'Deep Dive',
    //     description: "Go Deep - dive into your buyer's world, their language, their why, your solution, and your opportunity to create a deep dive that is tailored to your buyer and solution.",
    //     bgColor: 'bg-indigo-400/20',
    //     borderColor: 'border-indigo-400/20',
    //     textColor: 'text-indigo-300',
    //     iconBgColor: 'bg-indigo-400/10',
    //     tabValue: 'deep-dive' // Matches the tab value in KanbanBoard
    // }
]; 